import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useAdvisors } from "../context/useAdvisorsContext";

const WHATSAPP_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.84c0 2.09.55 4.13 1.59 5.93L0 24l6.38-1.67a11.83 11.83 0 0 0 5.66 1.44h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.37-8.45zM12.05 21.8h-.01a9.94 9.94 0 0 1-5.06-1.39l-.36-.21-3.78.99 1.01-3.69-.24-.38a9.93 9.93 0 0 1-1.52-5.28c0-5.48 4.46-9.94 9.97-9.94 2.66 0 5.16 1.04 7.04 2.92a9.88 9.88 0 0 1 2.92 7.04c0 5.49-4.47 9.94-9.97 9.94zm5.46-7.44c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.64-.93-2.24-.25-.59-.5-.51-.68-.52l-.58-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.12 3.24 5.14 4.54.72.31 1.28.49 1.71.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z" />
  </svg>
);

const tagStyle = (idx) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.4rem",
  padding: "0.55rem 0.9rem",
  borderRadius: "6px",
  fontSize: "0.88rem",
  fontWeight: 600,
  border: "1px solid #e2e2e2",
  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  backgroundColor: idx % 2 === 0 ? "#000321" : "#ffffff",
  color: idx % 2 === 0 ? "#ffffff" : "#000321",
});

const NuestrosAsesores = () => {
  const { data: advisors, isLoading, error } = useAdvisors();

  return (
    <section style={{ backgroundColor: "#ffffff", padding: "7rem 1rem 5rem" }}>
      <Container>
        <h2
          className="font-jura"
          style={{
            color: "#000321",
            fontWeight: 800,
            fontSize: "clamp(1.6rem, 2.6vw, 2.4rem)",
            marginBottom: "2.5rem",
          }}
        >
          NUESTROS ASESORES
        </h2>

        {isLoading && <p style={{ color: "#555" }}>Cargando asesores...</p>}
        {error && (
          <p style={{ color: "#555" }}>
            No pudimos cargar los asesores en este momento.
          </p>
        )}

        <div
          style={{ display: "flex", flexDirection: "column", gap: "3.25rem" }}
        >
          {advisors &&
            advisors.map((advisor) => {
              const waNumber = (advisor.whatsapp || "").replace(/[^\d]/g, "");
              const firstName = (advisor.name || "").split(" ")[0];
              const waLink = waNumber ? `https://wa.me/${waNumber}` : undefined;

              return (
                <Row key={advisor.id} className="g-4 align-items-start">
                  {/* Photo */}
                  <Col xs={12} md={4} lg={3}>
                    <div
                      style={{
                        width: "100%",
                        aspectRatio: "1 / 1",
                        backgroundColor: "#AFD89D",
                        overflow: "hidden",
                        borderRadius: "2px",
                      }}
                    >
                      {advisor.photoUrl ? (
                        <img
                          src={advisor.photoUrl}
                          alt={advisor.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "top center",
                            display: "block",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            background:
                              "linear-gradient(135deg, #AFD89D 0%, #8fb93e 100%)",
                          }}
                        />
                      )}
                    </div>
                  </Col>

                  {/* Info */}
                  <Col xs={12} md={8} lg={9}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.9rem",
                      }}
                    >
                      {/* Name + role */}
                      <div>
                        <h3
                          className="font-jura"
                          style={{
                            color: "#8fb93e",
                            fontWeight: 800,
                            fontSize: "clamp(1.9rem, 2.8vw, 2.6rem)",
                            margin: 0,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "0.6rem",
                          }}
                        >
                          {advisor.name}
                          <img
                            src="/images/check_icon.png"
                            alt="Verificado"
                            style={{ width: "28px", height: "28px" }}
                          />
                        </h3>
                        <p
                          style={{
                            color: "#000321",
                            fontWeight: 600,
                            fontSize: "1.05rem",
                            margin: 0,
                          }}
                        >
                          Asesora verificada Tu Carro por USA
                        </p>
                      </div>

                      {/* Description */}
                      <p
                        style={{
                          color: "#1a1d38",
                          fontSize: "1.05rem",
                          lineHeight: 1.55,
                          margin: 0,
                        }}
                      >
                        {advisor.description_es}
                      </p>

                      {/* Tags */}
                      {advisor.tags && advisor.tags.length > 0 && (
                        <div className="d-grid d-md-flex flex-wrap gap-2">
                          {advisor.tags.map((tag, idx) => (
                            <span key={idx} style={tagStyle(idx)}>
                              {tag.name_es}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* WhatsApp CTA */}
                      {waLink && (
                        <div className="d-grid d-md-flex justify-content-md-end">
                          <a
                            href={waLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "0.55rem",
                              backgroundColor: "#8fb93e",
                              color: "#ffffff",
                              padding: "0.7rem 1.3rem",
                              borderRadius: "6px",
                              textDecoration: "none",
                              fontWeight: 700,
                              fontSize: "0.95rem",
                            }}
                          >
                            Hablar con {firstName} ahora {WHATSAPP_ICON}
                          </a>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              );
            })}
        </div>
      </Container>
    </section>
  );
};

export default NuestrosAsesores;
